// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const USPS_TRACKING_URL_PREFIX = "https://tools.usps.com/go/TrackConfirmAction?tLabels=";
